import Row from 'antd/lib/row';
import FileTextOutlined from '@ant-design/icons/lib/icons/FileTextOutlined';
import { SECONDARY_COLOR } from 'src/theme';
import { NO_RATE_CLASS } from 'src/domain/customer-utility-bill/interface';
import { BillReadOnlyField } from './BillReadOnlyField';
import { BillSectionHeader } from './BillSectionHeader';
import { BillFormField, IBillSectionProps } from './BillFormField';

export const BillSiteInfoSection = (props: IBillSectionProps) => (
    <div className="customer-bill-section-source" style={{ marginBottom: 14 }}>
        <BillSectionHeader
            icon={<FileTextOutlined style={{ color: SECONDARY_COLOR }} />}
            title="Customer Utility Bill Information"
            fields={['siteName', 'siteNumber', 'accountNumber', 'enrollmentId', 'meterNumber', 'rateClass', 'controlProviderName']}
            editableFields={props.editableFields}
        />
        <Row gutter={[20, 10]}>
            {/* Customer isn't updatable — always read-only. */}
            <BillReadOnlyField label="CUSTOMER" value={props.form.customerName} />
            <BillFormField {...props} label="LOCATION" field="siteName" />
            <BillFormField {...props} label="STORE #" field="siteNumber" />
            <BillFormField {...props} label="ACCOUNT #" field="accountNumber" />
            <BillFormField {...props} label="ENROLLMENT ID (SAN)" field="enrollmentId" />
            <BillFormField {...props} label="METER #" field="meterNumber" />
            <BillFormField {...props} label="RATE CLASS" field="rateClass" emptyValue={NO_RATE_CLASS} />
            <BillFormField {...props} label="CONTROL PROVIDER" field="controlProviderName" />
        </Row>
    </div>
);
